import createApi from '@/utils/api.js'
import common from './common'
import easyBid from './easyBid'
import member from './member'
import {home, tender} from './home'
import {prod, store} from './mall'
import cart from './me-center/cart.js'
import address from './me-center/address.js'
import order from './me-center/order.js'
export default createApi({
  common,
  member,
  home,
  tender,
  prod,
  cart,
  store,
  address,
  order,
  easyBid
})



// WEBPACK FOOTER //
// ./src/api/apis/index.js